'use strict';
import {applyDefaultReduxListComponentOptions} from '../../core-utilities/redux/ReduxListContainer';
import {USER_PRIORITY} from '../enums/USER_PRIORITIES';
import {getAutoPrioritiesList} from '../reducers/state';
import {buildList, REDUX_OPTIONS} from './prioritiesListConfig';
import {AUTO_LIST_PREFIX} from './state';

/** @type {ReduxList} */
export const reduxList = buildList({
  prefix: AUTO_LIST_PREFIX,
  getState: getAutoPrioritiesList,
  listParams: `priority=${USER_PRIORITY.AUTO_PINNED}`,
}, {
  cacheName: 'AUTO_PINNED',
  priority: USER_PRIORITY.AUTO_PINNED,
});

export const componentOptions = applyDefaultReduxListComponentOptions(reduxList.options, {
  ...REDUX_OPTIONS,
  excludeFilterModalOptions: true,
  useInitFilter: true,
});



// WEBPACK FOOTER //
// ./src/js/priorities/redux/autoList.js